import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const usePredefinedCommentNavigation = () => {
    const navigate = useNavigate();

    const navigateToEdit = useCallback(
        (id: string) => {
            navigate(id);
        },
        [navigate]
    );

    const navigateToNew = useCallback(() => {
        navigate('new');
    }, [navigate]);

    return { navigateToEdit, navigateToNew };
};
